export default {
    methods: {
        scrollTextForwards(event) {
            const elem = event.target;
            $(elem).removeClass("ellipsis");
            const maxscroll = elem.offsetWidth * 5;
            const speed = maxscroll * 10;
            $(elem).stop().animate({scrollLeft: maxscroll}, speed);
        },
        scrollTextBackwards(event) {
            const elem = event.target;
            $(elem).stop();
            $(elem).animate({scrollLeft: 0}, 'slow', function () {
                $(elem).addClass("ellipsis");
            });
        }
    }
};

